<template slot-scope="scope">
  <!-- 个人钱包 表格组件 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#F5F5F5',
          textAlign: 'center',
          color: '#999999',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="文件名" align="center" >
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="版本" align="center" >
          <template slot-scope="scope">
            {{ scope.row.version }}
          </template>
        </el-table-column>
        <el-table-column label="发布时间" align="center" >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span
              style="color: #409eff "
              @click="handleView(scope.$index, scope.row)"
              >查看</span
            >
            <!-- <span
              class="span-Download"
              style="color: #409eff "
              @click="handleDownload(scope.$index, scope.row)"
              >下载</span
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ViewD
      :dialogVisible="dialogVisible"
      :dataObj="dataObj"
      @handleClose="handleClose"
    ></ViewD>
  </div>
</template>

<script>
import ViewD from "./View.vue";
import { postGetStsDowLoadPath } from "../../../../assets/api/index";
export default {
  props: {
    tableData: {},
  },
  components: { ViewD },
  data() {
    return {
      dialogVisible: false, // 查看协议弹窗
      dataObj: {},
    };
  },
  computed: {},
  created() {},
  methods: {
    // 查看
    handleView(index, row) {
      console.log(row);
      this.dataObj = row;
      this.dialogVisible = true;
    },
    // 关闭查看协议弹窗
    handleClose() {
      this.dialogVisible = !this.dialogVisible;
    },
    // 下载（暂时注释）
    // handleDownload(index, row) {
    //   postGetStsDowLoadPath(row.docId).then((res) => {
    //     if (res.code == 0) {
    //       let a = document.createElement("a");
    //       a.href = res.data;
    //       a.click();
    //     }
    //   });
    // },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
span {
  cursor: pointer;
}
.span-Download {
  margin-left: 20px;
}
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-last-child(2) {
  border-radius: 0 10px 0 0 !important;
}

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  // border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
  // border: 1px solid gold;
  margin-top: 20px;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  // background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
